import { array } from 'fp-ts';
import { ResourceResult } from '@mews-commander/data-access';
import { keyBy, keyById } from '@mews/fp';
import { Identifiable } from '@mews/std';
import { useResourcesGetAllQuery } from '@mews-commander/legacy-entities/src/queries/resources';

const extent = {
    resources: true,
    resourceCategories: true,
    resourceCategoryAssignments: true,
} as const;

const convertIntoRecord = <E extends Identifiable>(entity: Array<E> | null | undefined) =>
    entity && array.isNonEmpty(entity) ? keyById(entity) : undefined;

const select = (data: ResourceResult) => ({
    resources: convertIntoRecord(data.resources),
    resourceCategories: convertIntoRecord(data.resourceCategories),
    resourceCategoryAssignments:
        data.resourceCategoryAssignments && array.isNonEmpty(data.resourceCategoryAssignments)
            ? keyBy('resourceId', data.resourceCategoryAssignments)
            : undefined,
});

export const useResourcesCategoriesQuery = () => useResourcesGetAllQuery({ extent }, { select });
